// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import {computed} from 'nanostores';
import {MOBILE_WIDTH} from '../utils/constants.js';
import {$size} from './win_size.js';

export const $is_mobile = computed($size, size=>size[0] < MOBILE_WIDTH);
